import { render, staticRenderFns } from "./OrderListScreen.vue?vue&type=template&id=0b538d3a&"
import script from "./OrderListScreen.vue?vue&type=script&lang=ts&"
export * from "./OrderListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports